import { Css, useBreakpoint } from "@homebound/beam";
import { useMemo } from "react";
import { TradePartnerTaskStatus } from "src/generated/graphqlTypes";
import { useCurrentInternalUserQuery } from "src/queries/user.generated";
import {
  useActionItemsDelayFlagsQuery,
  useActionItemsSchedulingQuery,
  useActionItemsStaleTasksQuery,
} from "src/routes/personal-dashboard/pages/action-items/ActionItemsPage.generated";
import { nonClosedProjects } from "src/utils/projects";
import { filterScheduleFlagsByNonClosedStatus, getFirstNameFromInternalUser } from "../utils";

export function HeaderOverview() {
  const date = new Date();
  const { sm } = useBreakpoint();
  const { data: currentInternalUserData } = useCurrentInternalUserQuery({ fetchPolicy: "cache-first" });
  const internalUserName = currentInternalUserData?.currentInternalUser?.name!;
  const { data: delayFlags } = useActionItemsDelayFlagsQuery({
    variables: {
      internalUser: currentInternalUserData?.currentInternalUser?.id,
      scheduleParent: [],
      scheduleIsActive: true,
    },
  });
  const { data: staleTasks } = useActionItemsStaleTasksQuery({
    variables: {
      internalUser: currentInternalUserData?.currentInternalUser?.id,
      stale: true,
      projectStatus: nonClosedProjects,
    },
  });
  const { data: schedulingTasks } = useActionItemsSchedulingQuery({
    variables: { internalUser: currentInternalUserData?.currentInternalUser?.id, projectStatus: nonClosedProjects },
  });

  const filteredScheduleFlags = useMemo(() => {
    return delayFlags?.scheduleFlags.nonEmpty ? filterScheduleFlagsByNonClosedStatus(delayFlags?.scheduleFlags) : [];
  }, [delayFlags?.scheduleFlags]);

  const actionItemsCount = useMemo(
    () =>
      [
        filteredScheduleFlags.length ?? 0,
        staleTasks?.tasks?.length ?? 0,
        schedulingTasks?.tasks?.filter(
          (task) =>
            task.tradePartner !== null &&
            [TradePartnerTaskStatus.NeedsConfirmation, TradePartnerTaskStatus.NotSent].includes(
              task.tradePartnerStatus.code,
            ),
        ).length ?? 0,
      ].reduce((sum, count) => sum + count, 0),
    [filteredScheduleFlags, staleTasks, schedulingTasks],
  );

  const { firstName } = getFirstNameFromInternalUser(internalUserName);

  return (
    <div css={Css.df.gap2.$}>
      {!sm ? (
        <>
          <div css={Css.df.fdc.pr3.br.bw2.bcGray200.$}>
            <span css={Css.md.gray600.$}>{date.toLocaleDateString("en-US", { weekday: "short" })}</span>
            <span css={Css.xl2.df.jcc.$}>{date.toLocaleDateString("en-US", { day: "2-digit" })}</span>
          </div>
          <div css={Css.df.fdc.$}>
            <span css={Css.md.gray600.$}>{firstName}, you have</span>
            <span css={Css.xl2.$}>{actionItemsCount} action items today.</span>
          </div>
        </>
      ) : (
        <div css={Css.md.$}>
          {firstName}, you have <strong>{actionItemsCount} action items</strong> today.
        </div>
      )}
    </div>
  );
}
